import "./SuvaiContact.scss"
import store from "../../assets/images/store.png"
import seatings from "../../assets/images/seatings.png"
import reservation from "../../assets/reservation.svg"
import parking from "../../assets/parking.svg"
import privateDining from "../../assets/privateDining.svg"
import veg from "../../assets/veg.svg"

import { useSelector } from "react-redux";
import Button from "../../components/button/Button";
import { useEffect, useState } from "react";
import { contactEnquiry } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import InputComponent from "../../components/InputComponents/InputComponent";
import TextAreaComponent from "../../components/InputComponents/TextAreaComponent";
import { sortByOrderAscending } from "../../helper/helper"
const SuvaiContact = () => {
    const company = useSelector((state) => state.companyData.company)
    const [fullName, setFullName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [errors, setErrors] = useState({
        fullName: "",
        email: "",
        message: "",
        phoneNumber: "",
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        const nameRegex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;
        let newErrors = {
            fullName: "",
            email: "",
            message: "",
            phoneNumber: "",
        }
        const trimmedName = fullName.trim();
        const trimmedEmail = email.trim();
        const trimmedPhone = phoneNumber.trim();
        if (trimmedName === "") {
            newErrors.fullName = "*Required";
            valid = false;
        } else if (trimmedName.length < 2 || !nameRegex.test(trimmedName)) {
            newErrors.fullName = "Please enter a valid name";
            valid = false;
        }


        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }


        if (trimmedPhone === "") {
            newErrors.phoneNumber = "*Required";
            valid = false;
        }

        if (message.trim() === "") {
            newErrors.message = "*Required";
            valid = false;
        }
        console.log(newErrors, "newErrors", fullName, email, message, phoneNumber)
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": company?.ID || "",
            "Name": fullName,
            "Email": email,
            "PhoneNo": phoneNumber,
            "Message": message,
            "Subject": "",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setFullName("")
                setMessage("")
                setPhoneNumber("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }


    const getForm = () => {
        return (
            <div className="SuvaiContact-Form">
                <InputComponent
                    placeholder={"Name"}
                    value={fullName}
                    onChange={(e) => {
                        setFullName(e.target.value)
                        handleChange("fullName")
                    }}
                    error={errors.fullName !== ""}
                    errorText={errors.fullName}
                    required />
                <InputComponent
                    placeholder={"Email"}
                    onChange={(e) => {
                        setEmail(e.target.value)
                        handleChange("email")

                    }}
                    value={email}
                    error={errors.email !== ""}
                    errorText={errors.email}
                    required />
                <InputComponent
                    placeholder={"Mobile"}
                    onChange={(e) => {
                        setPhoneNumber(e.target.value)
                        handleChange("phoneNumber")

                    }}
                    value={phoneNumber}
                    error={errors.phoneNumber !== ""}
                    errorText={errors.phoneNumber}
                    type="number"
                    required />

                <TextAreaComponent
                    placeholder={"Message"}
                    onChange={(e) => {
                        setMessage(e.target.value)
                        handleChange("message")

                    }}
                    value={message}
                    error={errors.message !== ""}
                    errorText={errors.message}
                    required />
                {showSuccess && < div className="succes-alert">
                    ✔ Thanks for contacting us! We’ve received your message and will be in touch soon.
                </div>}

                <Button text={"SUBMIT"}
                    onClick={handleContact}
                    loading={loading} />
            </div>)
    }

    const Components = [
        {
            "ID": "SuvaiContact-hero",
            "Order": 1,
            "Type": "content",
            "Props": null,
            "Components": [
                {
                    "ID": "SuvaiContact-hero-TextContainer",
                    "Order": 1,
                    "Type": "content",
                    "Props": null,
                    "Components": [
                        {
                            "ID": "SuvaiContact-header",
                            "Order": 1,
                            "Type": "text",
                            "Props": {
                                "text": " Find Us"
                            }
                        },
                        {
                            "ID": "SuvaiContact-subheader",
                            "Order": 2,
                            "Type": "text",
                            "Props": {
                                "text": "WHERE"
                            }
                        },
                        {
                            "ID": "SuvaiContact-content",
                            "Order": 3,
                            "Type": "content",
                            "Props": {
                                "text": "203–205 Chesterfield Rd S, Mansfield NG19 7EQ, UK",
                                "text2": ""

                            }
                        },
                        {
                            "ID": "SuvaiContact-btnCont",
                            "Order": 4,
                            "Type": "content",
                            "Props": null,
                            "Components": [
                                {
                                    "ID": "SuvaiContact-button",
                                    "Order": 1,
                                    "Type": "button",
                                    "Props": {
                                        "btnText": "view map",
                                        "padding": "10px 20px",
                                        "width": "190px",
                                        "type": "PRIMARY",
                                        "href": ""
                                    }
                                },
                                {
                                    "ID": "SuvaiContact-button",
                                    "Order": 2,
                                    "Type": "button",
                                    "Props": {
                                        "btnText": "book a table",
                                        "padding": "10px 20px",
                                        "width": "190px",
                                        "type": "SECONDARY",
                                        "href": ""
                                    }
                                }
                            ]
                        },
                        {
                            "ID": "SuvaiContact-subheader",
                            "Order": 5,
                            "Type": "text",
                            "Props": {
                                "text": "WHEN"
                            }
                        },
                        {
                            "ID": "SuvaiContact-content",
                            "Order": 5,
                            "Type": "text",
                            "Props": {
                                "text": "Monday – Thursday",
                                "text2": "12:00 pm – 10.00 pm"
                            }
                        },
                        {
                            "ID": "SuvaiContact-content",
                            "Order": 6,
                            "Type": "text",
                            "Props": {
                                "text": "Friday - Sunday",
                                "text2": "12.00 am – 11.00 pm"
                            }
                        },
                    ]
                },
                {
                    "ID": "SuvaiContact-hero-Imagecontainer",
                    "Order": 2,
                    "Type": "content",
                    "Props": {
                        "bgSrc": store
                    },
                }
            ]
        },
        {
            "ID": "SuvaiContact-container",
            "Order": 2,
            "Type": "content",
            "Props": null,
            "Components": [
                {
                    "ID": "SuvaiContact-container-Imagecontainer",
                    "Order": 1,
                    "Type": "content",
                    "Props": {
                        "bgSrc": seatings
                    }
                }, {
                    "ID": "SuvaiContact-container-FormContainer",
                    "Order": 1,
                    "Type": "content",
                    "Props": null,
                    "Components": [
                        {
                            "ID": "SuvaiContact-container-FormContainer-header",
                            "Order": 1,
                            "Type": "text",
                            "Props": {
                                "text": "Get in Touch"
                            }
                        },
                        {
                            "ID": "SuvaiContact-container-FormContainer-subheader",
                            "Order": 2,
                            "Type": "text",
                            "Props": {
                                "text": "To get in touch fill out the contact form below or call us at  +44 1623 709999"
                            }
                        },
                        {
                            "ID": "SuvaiContact-container-FormContainer-form",
                            "Order": 3,
                            "Type": "form",
                            "Props": null
                        }
                    ]
                }
            ]
        },
        {
            "ID": "SuvaiContact-grid",
            "Order": 3,
            "Type": "content",
            "Props": null,
            "Components": [],
            "Data": [
                {
                    "src": reservation,
                    "header": "Reservations",
                    "content": "Highly recommended"
                },
                {
                    "src": parking,
                    "header": "Parking",
                    "content": "Street parking available"
                }, {
                    "src": privateDining,
                    "header": "Private Dining Room",
                    "content": "Perfect for special occasions"
                }, {
                    "src": veg,
                    "header": "Vegetarian",
                    "content": "Vegetarian options on request"
                }]
        },
    ]
    const getGridContainer = (data) => {
        return (
            <div className="SuvaiContact-grid">
                {data.map((item, index) => {
                    return (
                        <div key={index} className="SuvaiContact-grid-item">
                            <img alt="" src={item.src} className="SuvaiContact-grid-item-img" />
                            <div className="SuvaiContact-grid-item-header">{item.header}</div>
                            <div className="SuvaiContact-grid-item-content">{item.content}</div>


                        </div>
                    )
                })}
            </div>
        )
    }
    const getRightFormContainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiContact-container-FormContainer-header":
                return <div className="SuvaiContact-header">
                    {component?.Props.text}
                </div>
            case "SuvaiContact-container-FormContainer-subheader":
                return <div className="SuvaiContact-content">
                    {component?.Props.text}
                </div>
            case "SuvaiContact-container-FormContainer-form":
                return getForm()
            default:
                return <div />
        }

    }
    const getRightFormContainer = (components) => {
        return (
            <div className="SuvaiContact-hero2-left" >
                {sortByOrderAscending(components).map((component, key) => {
                    return getRightFormContainerComponents(component)
                })}
            </div>
        )

    }
    const getFormContainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiContact-container-Imagecontainer":
                return <div className="SuvaiContact-hero2-right"
                    style={{
                        backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${component?.Props?.bgSrc})`
                    }} />
            case "SuvaiContact-container-FormContainer":
                return getRightFormContainer(component?.Components)
            default:
                return <div />
        }

    }
    const getFormContainer = (components) => {
        return (<div className="SuvaiContact-hero2">
            {sortByOrderAscending(components).map((component, key) => {
                return getFormContainerComponents(component)
            })}
        </div>)
    }
    const getRightTextContainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiContact-header":
                return <div className="SuvaiContact-header">
                    {component?.Props.text}
                </div>
            case "SuvaiContact-subheader":
                return <div className="SuvaiContact-subheader">
                    {component?.Props.text}
                </div>
            case "SuvaiContact-content":
                return <div className="SuvaiContact-content">
                    {component?.Props.text}
                    {component?.Props.text2 !== "" && <><br />{component?.Props.text2}</>}
                </div>
            case "SuvaiContact-btnCont":
                return <div className="SuvaiContact-btnCont">
                    {component?.Components?.map((button, key) => {
                        return (
                            <Button
                                text={button?.Props.btnText}
                                padding={button?.Props.padding}
                                width={button?.Props.width}
                                type={button?.Props.type}
                                onClick={() => {
                                    if (button?.href && button?.href !== "") {
                                        window.open(button?.href, '_blank')
                                    }
                                }} />
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    const getRightTextContainer = (components) => {
        return (<div className="SuvaiContact-hero-left" style={{ paddingTop: "125px" }}>
            {sortByOrderAscending(components).map((component, key) => {
                return getRightTextContainerComponents(component)
            })}
        </div>)
    }
    const getHeroContainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiContact-hero-Imagecontainer":
                return <div className="SuvaiContact-hero-right"
                    style={{
                        backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${component?.Props?.bgSrc})`
                    }} />
            case "SuvaiContact-hero-TextContainer":
                return getRightTextContainer(component?.Components)
            default:
                return <div />
        }

    }
    const getHeroContainer = (components) => {
        return (<div className="SuvaiContact-hero">
            {sortByOrderAscending(components).map((component, key) => {
                return getHeroContainerComponents(component)
            })}
        </div>)
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "SuvaiContact-hero":
                return getHeroContainer(component?.Components)
            case "SuvaiContact-container":
                return getFormContainer(component?.Components)
            case "SuvaiContact-grid":
                return getGridContainer(component?.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="SuvaiContact">
            {sortByOrderAscending(Components).map((component, key) => {
                return getComponents(component)
            })}
        </div>
    )
}
export default SuvaiContact